import type {Router} from 'vue-router';
import {pagesPath} from '@/ts/router/pages-path';

/**
 * The logged-out landing page of the app a router belongs to: sign-up in the patient app, login in
 * the admin one, which has no sign-up page at all. Each router factory declares it, and code shared
 * by both apps — the 401 forced logout above all — reads it back from here rather than naming a
 * path only one of them has (IPD-3076).
 *
 * Its own module rather than part of router-utils.ts: asking the question must not drag the router,
 * and through it the generated locale bundles, into every consumer.
 */

const unauthenticatedRedirects = new WeakMap<Router, string>();

/** Where a router lands a session-less visitor when its factory names no other page */
export const DEFAULT_UNAUTHENTICATED_REDIRECT: string = pagesPath.public.signUp;

/** Records the landing page the factory declared for `router` */
export function setUnauthenticatedRedirect(router: Router, path: string): void {
  unauthenticatedRedirects.set(router, path);
}

/** The landing page declared for `router`, falling back to the patient app's sign-up */
export function unauthenticatedRedirectOf(router: Router): string {
  return unauthenticatedRedirects.get(router) ?? DEFAULT_UNAUTHENTICATED_REDIRECT;
}
